export const BULK_MAILER_API = {
    getCampaigns: 'v1/api/mailchimp/campaigns',
    deleteCampaign: 'v1/api/mailchimp/campaigns/',
    getActivityLogs: 'v1/api/mailchimp/campaigns/id/logs',
    getCampaignDetails: 'v1/api/mailchimp/campaigns/',
    createCampaign: 'v1/api/mailchimp/campaigns',
    updateCampaign: 'v1/api/mailchimp/campaigns/',
    getSegments: 'v1/api/mailchimp/audience',
    deleteSegments: 'v1/api/mailchimp/audience/',
    deleteSegmentsContacts: 'v1/api/mailchimp/audience/removeContacts',
    getSegmentsById: 'v1/api/mailchimp/audience/',
    createSegmanet: 'v1/api/mailchimp/audience',
    updateSegment: 'v1/api/mailchimp/audience/',
    getSegmentDetailsById: 'v1/api/mailchimp/audience/',
    getSegmentContacts: 'v1/api/mailchimp/audience/contacts/list',
    getEmailTemplates: 'v1/api/mailTemplates',
    createEmailTemplates: 'v1/api/mailTemplates',
    deleteTemplate: 'v1/api/mailTemplates?Id=',
    updateTemplate: 'v1/api/mailTemplates?Id=',
    importContacts: 'v1/api/mailchimp/audience/id/import',
    downloadContactFormat: 'v1/api/mailchimp/audience/template/download',
    exportContacts: 'v1/api/mailchimp/audience/export/list',
    getCourses: 'v1/api/courses',
    importMediaFiles: 'v1/api/media',
    getMediaFiles: 'v1/api/media',
    getTemplateVariable: 'v1/api/mailchimp/audience/template/variables',
    updateMediaFiles: 'v1/api/media?Id=',
    deleteMediaFiles: 'v1/api/media?Id=',
    getMailSender: 'v1/api/senders',
    createMailSender: 'v1/api/senders',
    deleteMailSender: 'v1/api/senders?Id=',
    updateMailSender: 'v1/api/senders?Id=',
    getUnsubscribeMailLog: 'v1/api/mailchimp/campaigns/unsubscribeAudienceMailLog',

    getTag: 'v1/api/tag',
    createTag: 'v1/api/tag',
    deleteTag: 'v1/api/tag?Id=',
    updateTag: 'v1/api/tag?Id=',
    getRecipientsWithTagsList: 'v1/api/mailchimp/audience/campaign/list',

    createUpdateContactSegment: 'v1/api/mailchimp/audience/contacts/update',
    testMail:'v1/api/mailchimp/campaigns/testMail',

    // Agent Report Campaigns
    getAgentReportCampaigns: 'v1/api/reportCampaign',
    getAgentReportCampaignDetails: 'v1/api/reportCampaign/getById',
    getAgentReportActivityLogs: 'v1/api/emailTracking',
}